import { CommonModule } from '@angular/common';
import { Component, effect, inject, input } from '@angular/core';
import { DxButtonModule, DxFormModule } from 'devextreme-angular';
import { alert } from 'devextreme/ui/dialog';
import { FormService } from '../services/form.service';
import { CardComponent } from './library/card/card.component';
import { FormTextAreaComponent } from './utils/form-text-area.component';
import { AppInfoService } from '../services';

@Component({
    selector: 'app-form-note',
    imports: [CommonModule, FormTextAreaComponent, CardComponent, DxFormModule, DxButtonModule],
    template: `
    <div class="cards-container">
      <card class="profile-card full-card">
        <dx-form class="form last plain-styled-form" labelMode="floating">
          <dxi-item>
            <form-text-area *dxTemplate label="Note" [isEditing]="true" [(value)]="text" height="100px"></form-text-area>
          </dxi-item>
        </dx-form>
        <dx-button type="default" text="Save Note" (onClick)="submit()" />
      </card>
    </div>
  `,
    styles: [
        `
      dx-button {
        margin-top: 10px;
      }
    `
    ]
})
export class FormNoteComponent {
  formService = inject(FormService);
  appInfo = inject(AppInfoService)

  formName = input.required<string>();
  formId = input.required<number>();

  text: string = '';

  constructor() {
    effect(async () => {
      const note = await this.formService.get<string>(FormService.Forms.Note, this.formId());
      this.text = note;
    });
  }

  async submit() {
    this.appInfo.isLoading.set(true);
    const result = await this.formService.post<any>(FormService.Forms.Note, {
      formId: this.formId(),
      formName: this.formName(),
      text: this.text
    });
    this.appInfo.isLoading.set(false);
    if (result.isSuccess) {
      this.text = result.value.text;
      this.appInfo.notify('Note saved');
    } else {
      await alert('Error saving note', 'Error');
    }
  }
}
